import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import http from '@lib/http-client'
import {
  DocumentsStore,
  IUserDocument,
  IUserDocumentWithDownload
} from './types'

export const useDocumentsStore = create<DocumentsStore>()(
  devtools(() => ({
    getUserDocuments: async (
      userId: number
    ): Promise<IUserDocument[] | null> => {
      try {
        const response: IUserDocument[] = await http.get(
          `/user/${userId}/documents`
        )
        return response
      } catch (error) {
        console.error('Error fetching user documents:', error)
        return null
      }
    },
    getUserDocumentById: async (
      userId: number,
      documentId: number
    ): Promise<IUserDocumentWithDownload | null> => {
      try {
        const response: IUserDocumentWithDownload = await http.get(
          `/user/${userId}/document/${documentId}`
        )
        return response
      } catch (error) {
        console.error('Error fetching user document:', error)
        return null
      }
    }
  }))
)
